const LISTED_FUND_TICKER = /^[A-Za-z]{4}11$/;
const LISTED_FUND_PREFIX = /^[A-Za-z]{4}$/;

export const normalizeTickerQuery = (query: string): string =>
    query.replace(/\s+/g, "").trim();

export const looksLikeListedFundTicker = (query: string): boolean =>
    LISTED_FUND_TICKER.test(normalizeTickerQuery(query));

export const shouldSearchListedFund = (query: string, stockResultCount: number): boolean => {
    const normalized = normalizeTickerQuery(query);
    if (normalized.length < 3) {
        return false;
    }
    if (looksLikeListedFundTicker(normalized)) {
        return true;
    }
    return stockResultCount === 0 && (LISTED_FUND_PREFIX.test(normalized) || /11$/i.test(normalized));
};
